var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"el",staticClass:"mt-2px mb-2px"})}
var staticRenderFns = []

export { render, staticRenderFns }